'use client';
import AppLayout from '@/components/AppLayout';
import KYCStatusScreen from './components/KYCStatusScreen';

export default function KYCStatusPage() {
  return (
    <AppLayout portalRole="investor">
      <KYCStatusScreen />
    </AppLayout>
  );
}
